import React, { useState }  from 'react'

import '@fortawesome/fontawesome-free/css/all.min.css'; // Import FontAwesome CSS
//import { Button } from 'bootstrap';
import { Button, Modal }  from 'react-bootstrap';
import { Badge, Card, Form, Table } from 'react-bootstrap';
import './Driver.css';

const Driver = () => {
    const [activeForm, setActiveForm] = useState(null);
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  return (
    <>
    
        <div style={{background:"#ccc"}}>
    <div className='container justify-content-center align-items-center vh-100'>
        <div class="row">
        <div class="col-md-8 col-lg-8" style={{margin:"0px auto"}}>
          <div class="card shadow" style={{background:"linear-gradient(90deg, #34495e, #556e88)"}}>
            <div class="card-body">
              <h4 class="card-title text-center text-white">Hello, Driver Saeed 👋</h4>
             
              <div class="text-center">
    
              <div className='container'>
                <div className='row'>
                    <div className='col-md-4'>
                        <div className='box'>
                        <h3 className='text-white'>1</h3>
                        <p className='text-white'>Active Deliveries</p>
                    </div>
                </div>
    
                    <div className='col-md-4'>
                         <div className='box'>
                        <h3 className='text-white'>AED 2,000</h3>
                        <p className='text-white'>Today's Collection</p>
                    </div>
                    </div>
    
                    <div className='col-md-4'>
                         <div className='box'>
                        <h3 className='text-white'>11</h3>
                        <p className='text-white'>Completed Dels</p>
                    </div>
                    </div>
    
                   
                </div>
                </div>
    
              </div>
    </div>
    </div>
    <div class="card shadow" style={{background:"#f7f7f7"}}>
            <div class="card-body">
    <div className="container">
         
          <div className="gap-3 mb-4">
           
          <div className='row'>
            <div className='col-md-2 padd0'>
           <Button className={`for_btn ${activeForm === "formA" ? "active" : ""}`} 
           variant='primary' onClick={() => setActiveForm("formA")}>    
           <i class="fas fa-trash"></i> Bin </Button>
           </div>
          <div className='col-md-3 padd0'>
          <Button className={`for_btn ${activeForm === "formB" ? "active" : ""}`} variant='success' onClick={() => setActiveForm("formB")}>
           <i class="fas fa-truck"></i>  Deliveries </Button>
         </div>
         <div className='col-md-3 padd0'>
         <Button className={`for_btn ${activeForm === "formC" ? "active" : ""}`} variant='warning' 
              onClick={() => setActiveForm("formC")}>  
              <i class="fas fa-credit-card"></i>  Payments </Button>
           </div>  
          <div className='col-md-2 padd0'>  
         <Button className={`for_btn ${activeForm === "formD" ? "active" : ""}`} variant="danger"
              onClick={() => setActiveForm("formD")}> 
              <i class="fas fa-exchange-alt"></i> Transfers</Button>
    
            </div>
            <div className='col-md-2 padd0'>  
         <Button className={`for_btn ${activeForm === "formE" ? "active" : ""}`} variant="danger"
              onClick={() => setActiveForm("formE")}> 
             <i class="fas fa-history"></i> History</Button>
    
            </div>
            </div>  
    
        
          </div>
    
          {/* Conditional Rendering */}
          {activeForm === "formA" && (
        <div>   
        <Card className='for_card'>
          
          <Card.Body>
           <div className='row'>
            <div className='col-md-12 text-left'>
            <Card.Text style={{textAlign:"left"}}>
               
           <h5>Order #ODR-2002 
            <h6><Badge bg='danger' style={{float:"right"}}>Available</Badge></h6></h5> 
            <b>Customer:</b> Abu Dhabi Traders<br/>
           <b>To:</b> Al Reem Island, AD<br/>
            <b>From:</b>Abu Dhabi Main Depot<br/>
            <b>Value:</b>AED 0<br/>
            <b>Distance:</b>9 km<br/>
            <b>Time Before:</b>01:30 PM
            </Card.Text>
            
            <Button variant="success" className='btn-sm' style={{float:'left'}}><i class="fas fa-check"></i> Accept </Button>
            <Button variant="danger" className='btn-sm' style={{marginLeft:"10px",float:'left'}}><i class="fas fa-times"></i> Reject </Button>
            <Button className="new-order-btn btn-sm" style={{marginLeft:"10px",float:'left'}}> <i class="fas fa-map"></i>Map </Button>
            </div>
            </div>
          </Card.Body>
        
        </Card>

       <Card className='for_card'>
          
          <Card.Body>
           <div className='row'>
            <div className='col-md-12 text-left'>
            <Card.Text style={{textAlign:"left"}}>
               
           <h5>Order #ODR-2002 
            <h6><Badge bg='danger' style={{float:"right"}}>Available</Badge></h6></h5> 
            <b>Customer:</b> Abu Dhabi Traders<br/>
           <b>To:</b> Al Reem Island, AD<br/>
            <b>From:</b>Abu Dhabi Main Depot<br/>
            <b>Value:</b>AED 0<br/>
            <b>Distance:</b>9 km<br/>
            <b>Time Before:</b>01:30 PM
            </Card.Text>
            
            <Button variant="success" className='btn-sm' style={{float:'left'}}><i class="fas fa-check"></i> Accept </Button>
            <Button variant="danger" className='btn-sm' style={{marginLeft:"10px",float:'left'}}><i class="fas fa-times"></i> Reject </Button>
            <Button className="new-order-btn btn-sm" style={{marginLeft:"10px",float:'left'}}> <i class="fas fa-map"></i>Map </Button>
            </div>
            </div>
          </Card.Body>
        
        </Card>

        </div>
    
    
          )}
    
          {activeForm === "formB" && (
            <Card>
          
          <Card.Body>
           <div className='row'>
            <div className='col-md-12 text-left'>
            <Card.Text style={{textAlign:"left"}}>
               
           <h5> ODR-1001 - Delivery <h6><Badge bg='success' style={{float:'right'}}>Accepted</Badge></h6></h5> 
            <b>Customer:</b> Al Maha Garage <br/>
            <b>To:</b> Al Quoz Industrial 4, Dubai<br/>
            <b>From:</b>  Jebel Ali Warehouse
            </Card.Text>
            
            <Button variant="secondary"  onClick={handleShow} className='btn-sm' style={{float:"left"}}>
                <i class="fas fa-eye"></i> View Details </Button>

                 <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                    <Modal.Title>Order #ODR-1001</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
<h5>Customer & Location</h5>
<b>Customer:</b> Al Maha Garage<br/>
<b>Pickup:</b> Jebel Ali Warehouse<br/>
<b>Delivery:</b> Al Quoz Industrial 4, Dubai<br/>
<b>Map Coords:</b> 25.10, 55.20

<img src='./map.png'/>

<h5>Order Status & Details</h5>
<b>Current Status:</b> <span className='status'>Picked Up</span><br/>
<b>Items/Invoice:</b> Invoice #INV-456 (Engine Parts)<br/>
<b>Amount Due:</b> AED 5,500<br/>

<Button>Delivery Complete</Button>
                    </Modal.Body>
                    <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button className="new-order-btn" onClick={handleClose}>
                        Save Changes
                    </Button>
                    </Modal.Footer>
                </Modal>
           
            </div>
            </div>
          </Card.Body>
        
        </Card>
        
          )}
    
          {activeForm === "formC" && (
               <Card>
          
          <Card.Body>
           <div className='row'>
            <div className='col-md-8 text-left'>
            <Card.Text style={{textAlign:"left"}}>
               
           <h5>Request #PAY-001</h5> 
           <b>Customer:</b> Global Auto Repair <br/>
           <b>Amount:</b> AED 7,200<br/>
            <b>Collected By:</b> Saeed<br/>
            <b>Method:</b> Cash<br/>
            </Card.Text>
            </div>
            <div className='col-md-4'>
            
            <Button variant="success">Assign </Button>
            <Button variant="secondary" style={{marginLeft:"10px"}}>View </Button>
            
          </div>
          </div>
          </Card.Body>
            <Card.Body>
           <div className='row'>
            <div className='col-md-8 text-left'>
            <Card.Text style={{textAlign:"left"}}>
               
           <h5>Request #PAY-001</h5> 
           <b>Customer:</b> Global Auto Repair <br/>
           <b>Amount:</b> AED 7,200<br/>
            <b>Collected By:</b> Saeed<br/>
            <b>Method:</b> Cash<br/>
            </Card.Text>
            </div>
            <div className='col-md-4'>
            
            <Button variant="success">Assign </Button>
            <Button variant="secondary" style={{marginLeft:"10px"}}>View </Button>
            
          </div>
          </div>
          </Card.Body>
             <Card.Body>
           <div className='row'>
            <div className='col-md-8 text-left'>
            <Card.Text style={{textAlign:"left"}}>
               
           <h5>Request #PAY-001</h5> 
           <b>Customer:</b> Global Auto Repair <br/>
           <b>Amount:</b> AED 7,200<br/>
            <b>Collected By:</b> Saeed<br/>
            <b>Method:</b> Cash<br/>
            </Card.Text>
            </div>
            <div className='col-md-4'>
            
            <Button variant="success">Assign </Button>
            <Button variant="secondary" style={{marginLeft:"10px"}}>View </Button>
            
          </div>
          </div>
          </Card.Body>
          
        </Card>
          )}
    
    
    
          
          {activeForm === "formd" && (
            <div className="card p-4">
    
           <Card>
            <Card.Body>
           <div className='row'>
            <div className='col-md-8 text-left'>
            <Card.Text style={{textAlign:"left"}}>
               
           <h5>Request #PAY-001</h5> 
           <b>Customer:</b> Global Auto Repair <br/>
           <b>Amount:</b> AED 7,200<br/>
            <b>Status:</b> <Badge bg='success'>Collected</Badge>
            </Card.Text>
            </div>
            <div className='col-md-4'>
             <Button variant="info">View </Button>
           </div>
          </div>
          </Card.Body>
          
        </Card>
    
    
    
            </div>
          )}
        </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      </div> 
    </>
  )
}

export default Driver